import React, { Component } from 'react';
import { connect } from 'react-redux';
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Media from "./Media";
import * as ResponseData from './Saga/ResponseData';
// import * as RentResponses from '../MonthlyMoney/Saga/MonthlyMoney';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Box from '@material-ui/core/Box';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns';

import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

interface Props {
    get_media_list: any,
    media_list: any,
    list: any,
    respose_list: any,
    response_search: any
}



interface State {
    selectedDate1: Date,
    selectedDate2: Date,
    media: Number,
    shop: Number,
}


const tenpo = [
    { id: 1, name: "番町" },
    { id: 2, name: "レインボー" },
    { id: 3, name: "高松駅前" },
    { id: 4, name: "高松東" },
    { id: 6, name: "中央公園" },
    { id: 17, name: "サンフラワー" },
    { id: 47, name: "中央通り" },
]


class MediaList extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            selectedDate1: new Date(),
            selectedDate2: new Date(),
            media: 0,
            shop: 0
        }
        this.alert = this.alert.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeShop = this.onChangeShop.bind(this);
        this.onChangeDate1 = this.onChangeDate1.bind(this);
        this.onChangeDate2 = this.onChangeDate2.bind(this);

    }

    alert() {

        // 日付の選択がおかしい
        if (this.state.selectedDate1 > this.state.selectedDate2) {
            alert("日付を正しく選択して下さい");
            return;
        }

        var section_id = [this.state.shop];
        if (this.state.shop == 0) {
            section_id = [1, 2, 3, 4, 6, 17, 47];
        }

        var data = {
            date1: this.state.selectedDate1,
            date2: this.state.selectedDate2,
            rent_m_medium_id: this.state.media,
            section_id: section_id
        }
        console.log(data);
        this.props.response_search(data);
    }


    onChange(e: any) {
        this.setState({
            media: e.target.value
        });
    }
    onChangeShop(e: any) {
        this.setState({
            shop: e.target.value
        });
    }

    onChangeDate1 = (date: any) => {
        this.setState({
            selectedDate1: new Date(date),
        });
    };
    onChangeDate2 = (date: any) => {
        this.setState({
            selectedDate2: new Date(date),
        });
    };


    render() {

        return (
            <div style={{ margin: "15px", marginRight: 50 }}>

                <div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            margin="normal"
                            id="date-picker-dialog"
                            label=""
                            format="yyyy/MM/dd"
                            value={this.state.selectedDate1}
                            onChange={this.onChangeDate1}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>

                    <i className="fas fa-long-arrow-alt-right" style={{ margin: 10, fontSize: 20 }}></i>


                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            margin="normal"
                            id="date-picker-dialog"
                            label=""
                            format="yyyy/MM/dd"
                            value={this.state.selectedDate2}
                            onChange={this.onChangeDate2}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div>
                    <FormControl>
                        <InputLabel htmlFor="uncontrolled-native">メディアを選択</InputLabel>
                        <NativeSelect
                            onChange={this.onChange}
                            inputProps={{
                                name: 'メディアを選択',
                                id: 'uncontrolled-native',
                            }}
                        >
                            <option value={0}></option>
                            {this.props.list.map((d: any) => (
                                <option key={d.id} value={d.id}>
                                    {d.name}
                                </option>
                            ))}
                        </NativeSelect>
                    </FormControl>

                    <FormControl>
                        <InputLabel htmlFor="uncontrolled-native">店舗を選択</InputLabel>
                        <NativeSelect
                            onChange={this.onChangeShop}
                            inputProps={{
                                name: '店舗を選択',
                                id: 'uncontrolled-native',
                            }}
                        >
                            <option value={0}></option>
                            {tenpo.map((d: any) => (
                                <option key={d.id} value={d.id}>
                                    {d.name}
                                </option>
                            ))}
                        </NativeSelect>
                    </FormControl>

                    <Button style={{ margin: "15px", marginLeft: 70 }} variant="outlined" color="primary" onClick={this.alert}>
                        検索
                </Button>
                </div>
            </div>
        );
    }
};


const mapStateToProps = (state: any) => {
    return {

        media_list: state.ResponseData.media_list,
        respose_list: state.ResponseData.respose_list,


    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_media_list(state: any) {
            dispatch(ResponseData.get_media_list(state))
        },
        response_search(state: any) {
            dispatch(ResponseData.response_search(state))
        },


    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MediaList);




